import src from "IMAGE";
export default { src, width: 524, height: 128, blurWidth: 0, blurHeight: 0};
